<template>

  <head>

    <meta charset="utf-8" />
    <title>County Revenue System | Revenue Collection Report</title>
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <meta content="Revenue management system" name="description" />
    <meta content="County Team" name="author" />
    <!-- App favicon -->
    <link rel="shortcut icon" href="assets/images/favicon.svg">
    <!-- droping file -->
    <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css" />

    <!-- DataTables -->
    <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css" />
    <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css" />

    <!-- Bootstrap Css -->
    <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
    <!-- Bootstrap select styling -->
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">
    <!-- Icons Css -->
    <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />
    <!-- App Css-->
    <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
    <!-- custom Css-->
    <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />



  </head>

  <body data-sidebar="dark">

  <!-- Begin page -->
  <div id="layout-wrapper">


    <NavigationBar/>

    <!-- ============================================================== -->
    <!-- Start right Content here -->
    <!-- ============================================================== -->
    <div id="content" class="content-minimize">

      <div class="page-content">
        <div class="container-fluid">

          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 class="mb-sm-0 font-size-18">
                  <i class="bx bx-map-alt me-2"></i>
                  {{subCountyName || 'All Sub Counties'}} Revenue Collection
                </h4>

                <div class="page-title-right">
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboard</a></li>
                    <li class="breadcrumb-item"><a @click="gotTo('reports-sub-county')">Reports</a></li>
                    <li class="breadcrumb-item active">Revenue Details</li>
                  </ol>
                </div>

              </div>
            </div>
          </div>
          <!-- end page title -->

          <!-- Stats Row -->
          <div class="row">
            <div class="col-md-4">
              <div class="stats-card primary">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <h3>KES {{numberFormat(totalAmount || 0)}}</h3>
                    <p>Total Collection</p>
                  </div>
                  <div class="ms-3">
                    <i class="bx bx-money text-primary" style="font-size: 2.5rem; opacity: 0.4;"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="stats-card success">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <h3>{{billDetails.length}}</h3>
                    <p>Total Transactions</p>
                  </div>
                  <div class="ms-3">
                    <i class="bx bx-receipt text-success" style="font-size: 2.5rem; opacity: 0.4;"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="stats-card info">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <h3>{{formatDate(dateFrom)}} - {{formatDate(dateTo)}}</h3>
                    <p>Report Period</p>
                  </div>
                  <div class="ms-3">
                    <i class="bx bx-calendar text-info" style="font-size: 2.5rem; opacity: 0.4;"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-header bg-white d-flex justify-content-between align-items-center w-100 border-bottom p-3">
                  <div>
                    <h5 class="mb-0">
                      <i class="bx bx-receipt me-2"></i>
                      {{incomeTypePrefix === 'UNRECIEPTED' ? 'Unreceipted' : feeDescription || 'All'}} Transactions
                    </h5>
                    <p class="text-muted mb-0 mt-1">
                      {{incomeTypeDescription || 'All income types'}}
                    </p>
                  </div>
                </div>

                <div class="card-header bg-white pt-0 pr-0 p-0 d-flex justify-content-between align-items-center w-100 border-bottom">
                  <div class="btn-toolbar p-3 d-flex justify-content-between align-items-center w-100" role="toolbar">
                    <div class="flex-grow-1">
                      <div class="search-box mb-0 me-3">
                        <div class="position-relative">
                          <input
                              v-model="searchQuery"
                              type="text"
                              class="form-control bg-light border-light rounded"
                              placeholder="Search by name, transaction code, receipt number, or account..."
                          >
                          <i class="bx bx-search-alt search-icon"></i>
                        </div>
                      </div>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                      <div class="d-flex align-items-center me-3">
                        <span class="me-2 fw-semibold text-nowrap">Date Range:</span>
                        <input v-model.lazy="dateFrom" class="form-control me-2" type="date" @change="handleDateChange">
                        <span class="px-2">to</span>
                        <input v-model.lazy="dateTo" class="form-control" type="date" @change="handleDateChange">
                      </div>

                      <div class="btn-group" role="group">
                        <button
                            v-if="getRight('DOWNLOAD REPORTS')"
                            @click="downloadReceiptsPaginatedBySubCounty"
                            type="button"
                            class="btn btn-success"
                            :disabled="loading || billDetails.length === 0"
                            title="Export current page"
                        >
                          <i class="bx bxs-download font-size-16 align-middle me-1"></i>
                          <span>Current Page</span>
                        </button>

                        <button
                            v-if="getRight('DOWNLOAD REPORTS')"
                            @click="exportAllRecords"
                            type="button"
                            class="btn btn-primary"
                            :disabled="loading || summary.count === 0 || exportingAll"
                            title="Export all records with progress"
                        >
                          <span v-if="exportingAll">
                            <span class="spinner-border spinner-border-sm me-2" role="status"></span>
                            Exporting...
                          </span>
                          <span v-else>
                            <i class="bx bx-cloud-download font-size-16 align-middle me-1"></i>
                            <span>Export All ({{numberFormat(summary.count)}})</span>
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-body">
                  <!-- Loading State -->
                  <div v-if="loading" class="text-center py-5">
                    <div class="spinner-border text-primary mb-3" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <h5 class="text-muted">Loading transactions...</h5>
                    <p class="text-muted">Please wait while we fetch your data</p>
                  </div>

                  <!-- Empty State -->
                  <div v-else-if="billDetails.length === 0" class="empty-state text-center">
                    <img :src="'./assets/images/no-results.png'" alt="No results" class="mb-4"/>
                    <h4>No Transactions Found</h4>
                    <p class="text-muted">No transactions match your current filters. Try adjusting your search criteria.</p>
                  </div>

                  <!-- Data Table -->
                  <div v-else class="table-responsive">
                    <table class="table align-middle table-hover table-striped">
                      <thead class="table-light">
                      <tr>
                        <th @click="sortBy('transaction_code')" class="sortable-header">
                          Transaction Code
                          <i class="bx ms-1" :class="getSortIcon('transaction_code')"></i>
                        </th>
                        <th @click="sortBy('receiptNo')" class="sortable-header">
                          Receipt No
                          <i class="bx ms-1" :class="getSortIcon('receiptNo')"></i>
                        </th>
                        <th @click="sortBy('paidBy')" class="sortable-header">
                          Paid By
                          <i class="bx ms-1" :class="getSortIcon('paidBy')"></i>
                        </th>
                        <th @click="sortBy('date')" class="sortable-header">
                          Date & Time
                          <i class="bx ms-1" :class="getSortIcon('date')"></i>
                        </th>
                        <th @click="sortBy('payment_type')" class="sortable-header">
                          Payment Method
                          <i class="bx ms-1" :class="getSortIcon('payment_type')"></i>
                        </th>
                        <th @click="sortBy('accountName')" class="sortable-header">
                          Account Name
                          <i class="bx ms-1" :class="getSortIcon('accountName')"></i>
                        </th>
                        <th @click="sortBy('account_ref')" class="sortable-header">
                          Reference
                          <i class="bx ms-1" :class="getSortIcon('account_ref')"></i>
                        </th>
                        <th @click="sortBy('subCountyName')" class="sortable-header">
                          Sub County
                          <i class="bx ms-1" :class="getSortIcon('subCountyName')"></i>
                        </th>
                        <th @click="sortBy('wardName')" class="sortable-header">
                          Ward
                          <i class="bx ms-1" :class="getSortIcon('wardName')"></i>
                        </th>
                        <th @click="sortBy('zone')" class="sortable-header">
                          Zone
                          <i class="bx ms-1" :class="getSortIcon('zone')"></i>
                        </th>
                        <th @click="sortBy('description')" class="sortable-header">
                          Description
                          <i class="bx ms-1" :class="getSortIcon('description')"></i>
                        </th>
                        <th @click="sortBy('amount')" class="sortable-header text-end">
                          Amount
                          <i class="bx ms-1" :class="getSortIcon('amount')"></i>
                        </th>
                        <th class="text-center">Actions</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="(item, index) in paginatedData" :key="index">
                        <td class="transaction-code">
                          {{item.transaction_code}}
                        </td>
                        <td>
                          <div class="receipt-no">
                            <strong>{{item.receiptNo || item.billNo || '-'}}</strong>
                          </div>
                        </td>
                        <td>
                          <div>
                            <strong>{{capitalizeName(item.paidBy || item.names)}}</strong>
                            <br>
                            <small class="text-muted">{{formatPhone(item.account_from)}}</small>
                          </div>
                        </td>
                        <td>
                          <div>
                            {{formatDate(item.date)}}
                            <br>
                            <small class="text-muted">{{formatTime(item.date)}}</small>
                          </div>
                        </td>
                        <td>
                          <span class="badge bg-info">{{item.payment_type || item.source}}</span>
                        </td>
                        <td>
                          <div>
                            <strong>{{item.accountName}}</strong>
                            <br>
                            <small class="text-muted">To: {{item.account_to}}</small>
                          </div>
                        </td>
                        <td>
                          {{item.account_ref || '-'}}
                        </td>
                        <td>
                          {{item.subCountyName || '-'}}
                        </td>
                        <td>
                          {{item.wardName || '-'}}
                        </td>
                        <td>
                          {{item.zone || '-'}}
                        </td>
                        <td>
                          <div class="description-cell">
                            {{item.description || '-'}}
                          </div>
                        </td>
                        <td class="text-end amount-cell">
                          KES {{numberFormat(item.amount || item.receiptAmount)}}
                        </td>
                        <td class="text-center">
                          <button
                              @click="viewTransaction(item)"
                              class="btn btn-sm btn-outline-primary"
                              title="View Details"
                          >
                            <i class="bx bx-show"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                      <tfoot class="table-dark">
                      <tr>
                        <th colspan="10">
                          Showing {{paginatedData.length}} of {{filteredData.length}} transactions
                          <span v-if="searchQuery" class="text-warning">(filtered)</span>
                        </th>
                        <td colspan="2" class="text-end">
                          <strong>Page Total:</strong>
                        </td>
                        <td class="text-end">
                          <strong>KES {{numberFormat(pageTotal)}}</strong>
                        </td>
                      </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>

                <!-- Pagination -->
                <div class="card-footer bg-white" v-if="billDetails.length > 0 && pageSize !== ''">
                  <nav aria-label="Page navigation" class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <span class="me-3">Rows per page:</span>
                      <select class="form-select w-auto" v-model="pageSize">
                        <option :value="10">10</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                        <option :value="200">200</option>
                        <option :value="''">All</option>
                      </select>
                    </div>

                    <ul class="pagination mb-0">
                      <li class="page-item" :class="{ disabled: currentPage === 1 }">
                        <a class="page-link" @click="prevPage" :disabled="currentPage === 1">
                          <i class="bx bx-chevron-left"></i>
                        </a>
                      </li>

                      <li
                          v-for="page in pagination(currentPage, totalPages, 5)"
                          :key="page"
                          class="page-item"
                          :class="{ active: currentPage === page }"
                      >
                        <span v-if="page === '...'" class="page-link">{{ page }}</span>
                        <a v-else class="page-link" @click="goToPage(page)">{{ page }}</a>
                      </li>

                      <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                        <a class="page-link" @click="nextPage" :disabled="currentPage === totalPages">
                          <i class="bx bx-chevron-right"></i>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <!-- Transaction Details Modal -->
      <div class="modal fade" id="transactionModal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Transaction Details</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body" v-if="selectedTransaction">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="text-muted mb-3">Transaction Information</h6>
                  <table class="table table-sm">
                    <tr>
                      <td class="fw-semibold">Transaction Code:</td>
                      <td>{{selectedTransaction.transaction_code}}</td>
                    </tr>
                    <tr v-if="selectedTransaction.receiptNo || selectedTransaction.billNo">
                      <td class="fw-semibold">Receipt No:</td>
                      <td>{{selectedTransaction.receiptNo || selectedTransaction.billNo}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Date Created:</td>
                      <td>{{formatDateTime(selectedTransaction.date)}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Payment Type:</td>
                      <td>{{selectedTransaction.payment_type}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Amount:</td>
                      <td class="fw-bold text-success">KES {{numberFormat(selectedTransaction.amount)}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Status:</td>
                      <td><span class="badge badge-soft-success">{{selectedTransaction.status}}</span></td>
                    </tr>
                    <tr v-if="selectedTransaction.incomeTypeDescription">
                      <td class="fw-semibold">Income Type:</td>
                      <td>{{selectedTransaction.incomeTypeDescription}}</td>
                    </tr>
                    <tr v-if="selectedTransaction.feeDescription">
                      <td class="fw-semibold">Fee Description:</td>
                      <td>{{selectedTransaction.feeDescription}}</td>
                    </tr>
                    <tr v-if="selectedTransaction.subCountyName">
                      <td class="fw-semibold">Sub County:</td>
                      <td>{{selectedTransaction.subCountyName}}</td>
                    </tr>
                    <tr v-if="selectedTransaction.wardName">
                      <td class="fw-semibold">Ward:</td>
                      <td>{{selectedTransaction.wardName}}</td>
                    </tr>
                    <tr v-if="selectedTransaction.zone">
                      <td class="fw-semibold">Zone:</td>
                      <td>{{selectedTransaction.zone}}</td>
                    </tr>
                    <tr v-if="selectedTransaction.description">
                      <td class="fw-semibold">Description:</td>
                      <td>{{selectedTransaction.description}}</td>
                    </tr>
                  </table>
                </div>
                <div class="col-md-6">
                  <h6 class="text-muted mb-3">Account Details</h6>
                  <table class="table table-sm">
                    <tr>
                      <td class="fw-semibold">Account Name:</td>
                      <td>{{selectedTransaction.accountName}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Account To:</td>
                      <td>{{selectedTransaction.account_to}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Account From:</td>
                      <td>{{formatPhone(selectedTransaction.account_from)}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Reference:</td>
                      <td>{{selectedTransaction.account_ref || '-'}}</td>
                    </tr>
                    <tr>
                      <td class="fw-semibold">Paid By:</td>
                      <td>{{selectedTransaction.paidBy}}</td>
                    </tr>
                    <tr v-if="selectedTransaction.receiptedBy">
                      <td class="fw-semibold">Receipted By:</td>
                      <td>
                        {{selectedTransaction.receiptedBy}}
                        <br v-if="selectedTransaction.receiptedByPhoneNumber">
                        <small class="text-muted" v-if="selectedTransaction.receiptedByPhoneNumber">
                          {{formatPhone(selectedTransaction.receiptedByPhoneNumber)}}
                        </small>
                      </td>
                    </tr>
                    <tr v-if="selectedTransaction.department">
                      <td class="fw-semibold">Department:</td>
                      <td>{{selectedTransaction.department}}</td>
                    </tr>
                  </table>
                </div>
              </div>

              <div class="row mt-3" v-if="selectedTransaction.incomeTypePrefix === 'UNRECIEPTED'">
                <div class="col-12">
                  <div class="alert alert-warning">
                    <i class="bx bx-info-circle me-2"></i>
                    This is an unreceipted transaction. Additional processing may be required.
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary" v-if="selectedTransaction && selectedTransaction.billNo" @click="printBill(selectedTransaction.billNo)">
                <i class="bx bx-printer me-2"></i>Print Receipt
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Export Progress Modal -->
      <div class="modal fade" id="exportProgressModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header bg-primary text-white">
              <h5 class="modal-title text-white">
                <i class="bx bxs-download me-2"></i>Exporting All Records
              </h5>
            </div>
            <div class="modal-body">
              <div class="text-center mb-3">
                <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem;" role="status" v-if="!exportPaused">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <div v-else class="mb-3">
                  <i class="bx bx-pause-circle text-warning" style="font-size: 3rem;"></i>
                </div>
                <h5 v-if="!exportPaused">Please wait while we export your records...</h5>
                <h5 v-else class="text-warning">Export Paused</h5>

                <!-- Estimated Time Remaining -->
                <div v-if="exportProgress.estimatedTimeRemaining && !exportPaused" class="mt-2">
                  <p class="text-muted mb-1">
                    <i class="bx bx-time-five me-1"></i>
                    <strong>{{ formatTimeRemaining(exportProgress.estimatedTimeRemaining) }}</strong> remaining
                  </p>
                  <small class="text-muted">
                    Average speed: {{ exportProgress.averageSpeed }} records/sec
                  </small>
                </div>

                <p class="text-muted mt-2">{{ exportPaused ? 'You can resume or cancel the export.' : 'This may take several minutes depending on the amount of data.' }}</p>
              </div>

              <div class="progress mb-3" style="height: 25px;">
                <div
                    class="progress-bar progress-bar-striped"
                    :class="{'progress-bar-animated': !exportPaused, 'bg-warning': exportPaused}"
                    role="progressbar"
                    :style="{ width: exportProgress.percentage + '%' }"
                    :aria-valuenow="exportProgress.percentage"
                    aria-valuemin="0"
                    aria-valuemax="100">
                  {{ exportProgress.percentage }}%
                </div>
              </div>

              <div class="d-flex justify-content-between text-muted small mb-3">
                <span>Page {{ exportProgress.current }} of {{ exportProgress.total }}</span>
                <span>{{ exportProgress.records }} / {{ numberFormat(exportProgress.totalRecords) }} records</span>
              </div>

              <!-- Error Display -->
              <div v-if="exportError" class="alert alert-danger d-flex align-items-center" role="alert">
                <i class="bx bx-error-circle me-2"></i>
                <div class="flex-grow-1">
                  <strong>Error:</strong> {{ exportError }}
                  <br>
                  <small>You can retry from where it stopped or cancel the export.</small>
                </div>
              </div>

              <!-- Retry Count Display -->
              <div v-if="exportRetryCount > 0" class="alert alert-warning d-flex align-items-center mb-3" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>Retry attempt {{ exportRetryCount }} of 3</small>
              </div>

              <!-- Action Buttons -->
              <div class="d-flex gap-2 justify-content-center mb-3">
                <button
                    v-if="!exportPaused && !exportError"
                    @click="pauseExport"
                    class="btn btn-warning btn-sm">
                  <i class="bx bx-pause me-1"></i>Pause
                </button>
                <button
                    v-if="exportPaused || exportError"
                    @click="resumeExport"
                    class="btn btn-success btn-sm">
                  <i class="bx bx-play me-1"></i>Resume
                </button>
                <button
                    @click="cancelExport"
                    class="btn btn-danger btn-sm">
                  <i class="bx bx-x me-1"></i>Cancel
                </button>
              </div>

              <div class="alert alert-info d-flex align-items-center" role="alert">
                <i class="bx bx-info-circle me-2"></i>
                <small>{{ exportPaused ? 'Export is paused. Your progress has been saved.' : 'Please do not close this window or navigate away.' }}</small>
              </div>

              <!-- Export Statistics -->
              <div v-if="exportProgress.records > 0" class="mt-3 pt-3 border-top">
                <div class="row text-center">
                  <div class="col-4">
                    <small class="text-muted d-block">Exported</small>
                    <strong>{{ numberFormat(exportProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Remaining</small>
                    <strong>{{ numberFormat(exportProgress.totalRecords - exportProgress.records) }}</strong>
                  </div>
                  <div class="col-4">
                    <small class="text-muted d-block">Success Rate</small>
                    <strong>{{ getSuccessRate() }}%</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer">
        <div class="container-fluid">
          <div class="row">
            <div class="col-sm-6">
              © {{new Date().getFullYear()}} County Revenue System
            </div>
            <div class="col-sm-6">
              <div class="text-sm-end d-sm-block">
                Powered by County IT Department
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>

  </body>
</template>

<script>
/* eslint-disable */
import {biller, execute, getRight} from "@/api";
import NavigationBar from "@/components/Navigation";
import moment from "moment";

export default {
  name: "ReportsSubCountyStreamsDetails",
  components: {
    NavigationBar
  },
  data() {
    return {
      loading: false,
      currentPage: 1,
      totalPages: 0,
      pageSize: 25,
      totalItems: 0,
      subCountyName: '',
      subCountyID: '',
      dateTo: '',
      dateFrom: '',
      totalAmount: null,
      billDetails: [],
      incomeTypeDescription: '',
      feeDescription: '',
      incomeTypePrefix: '',
      amountCollected: 0,
      searchQuery: '',

      // Sorting
      sortColumn: null,
      sortDirection: 'asc',

      selectedTransaction: null,

      // Summary for export
      summary: { count: 0, total: 0 },

      // Export All functionality
      exportingAll: false,
      exportPaused: false,
      exportCancelled: false,
      exportError: null,
      exportRetryCount: 0,
      maxRetries: 3,
      exportProgress: {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      },
      allExportData: [],
      exportState: {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      }
    };
  },
  computed: {
    filteredData() {
      if (!this.searchQuery) {
        return this.billDetails;
      }

      const query = this.searchQuery.toLowerCase();
      return this.billDetails.filter(item => {
        return (
            (item.transaction_code && item.transaction_code.toLowerCase().includes(query)) ||
            (item.receiptNo && item.receiptNo.toLowerCase().includes(query)) ||
            (item.billNo && item.billNo.toLowerCase().includes(query)) ||
            (item.paidBy && item.paidBy.toLowerCase().includes(query)) ||
            (item.names && item.names.toLowerCase().includes(query)) ||
            (item.accountName && item.accountName.toLowerCase().includes(query)) ||
            (item.account_ref && item.account_ref.toLowerCase().includes(query)) ||
            (item.payment_type && item.payment_type.toLowerCase().includes(query)) ||
            (item.type && item.type.toLowerCase().includes(query)) ||
            (item.status && item.status.toLowerCase().includes(query)) ||
            (item.subCountyName && item.subCountyName.toLowerCase().includes(query)) ||
            (item.wardName && item.wardName.toLowerCase().includes(query)) ||
            (item.zone && item.zone.toLowerCase().includes(query)) ||
            (item.description && item.description.toLowerCase().includes(query))
        );
      });
    },

    sortedData() {
      if (!this.sortColumn) return this.filteredData;

      const sorted = [...this.filteredData];
      sorted.sort((a, b) => {
        let aVal = this.getNestedValue(a, this.sortColumn);
        let bVal = this.getNestedValue(b, this.sortColumn);

        // Handle amount sorting
        if (this.sortColumn === 'amount') {
          aVal = parseFloat(a.amount || a.receiptAmount || 0);
          bVal = parseFloat(b.amount || b.receiptAmount || 0);
        }
        // Handle date sorting
        else if (this.sortColumn === 'date') {
          aVal = new Date(aVal || 0);
          bVal = new Date(bVal || 0);
        }
        // Handle string sorting
        else {
          aVal = String(aVal || '').toLowerCase();
          bVal = String(bVal || '').toLowerCase();
        }

        if (this.sortDirection === 'asc') {
          return aVal > bVal ? 1 : aVal < bVal ? -1 : 0;
        } else {
          return aVal < bVal ? 1 : aVal > bVal ? -1 : 0;
        }
      });

      return sorted;
    },

    paginatedData() {
      return this.sortedData;
    },

    pageTotal() {
      return this.paginatedData.reduce((acc, item) => {
        return acc + parseFloat(item.amount || item.receiptAmount || 0);
      }, 0);
    }
  },
  watch: {
    pageSize() {
      this.currentPage = 1;
      this.getReceiptsPaginatedBySubCounty();
    },
    searchQuery() {
      this.currentPage = 1;
      this.getReceiptsPaginatedBySubCounty();
    }
  },
  mounted() {
    this.subCountyID = sessionStorage.getItem("subCountyID");
    this.subCountyName = sessionStorage.getItem("subCountyName");
    this.dateTo = sessionStorage.getItem("dateTo");
    this.dateFrom = sessionStorage.getItem("dateFrom");
    this.incomeTypeDescription = sessionStorage.getItem("incomeTypeDescription");
    this.feeDescription = sessionStorage.getItem("feeDescription");
    this.incomeTypePrefix = sessionStorage.getItem("incomeTypePrefix");
    this.amountCollected = sessionStorage.getItem("amountCollected");

    this.getReceiptsPaginatedBySubCounty();
    this.menuAccess();
  },
  methods: {
    // Sorting
    sortBy(column) {
      if (this.sortColumn === column) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }
    },

    getSortIcon(column) {
      if (this.sortColumn !== column) {
        return 'bx-sort text-muted';
      }
      return this.sortDirection === 'asc' ? 'bx-sort-up text-primary' : 'bx-sort-down text-primary';
    },

    handleDateChange() {
      if (this.dateFrom && this.dateTo) {
        this.getReceiptsPaginatedBySubCounty();
      }
    },

    getNestedValue(obj, path) {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "Reports Sub County Stream Details");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));
      execute(data, biller)
          .then((res) => {
            // Handle response
          })
          .catch((e) => {
            console.error(e);
          });
    },

    getRight(type) {
      return getRight(type);
    },

    pagination(currentPage, totalPages, maxVisibleButtons) {
      let pages = [];
      let start = currentPage - Math.floor(maxVisibleButtons / 2);
      let end = currentPage + Math.floor(maxVisibleButtons / 2);

      if (start < 1) {
        start = 1;
        end = start + maxVisibleButtons - 1;
        if (end > totalPages) {
          end = totalPages;
        }
      }
      if (end > totalPages) {
        end = totalPages;
        start = end - maxVisibleButtons + 1;
        if (start < 1) {
          start = 1;
        }
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      if (start > 1) {
        pages.unshift("...");
        pages.unshift(1);
      }
      if (end < totalPages) {
        pages.push("...");
        pages.push(totalPages);
      }

      return pages;
    },

    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.getReceiptsPaginatedBySubCounty();
      }
    },

    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.getReceiptsPaginatedBySubCounty();
      }
    },

    goToPage(page) {
      if (page > 0 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.getReceiptsPaginatedBySubCounty();
      }
    },

    gotTo(route) {
      this.$router.push(route);
    },

    formatDate(date) {
      if (!date) return '';
      let d = new Date(date);
      let day = d.getDate();
      let month = d.toLocaleString('en-US', { month: 'short' });
      let year = d.getFullYear();

      let suffix = '';
      if (day % 10 === 1 && day !== 11) {
        suffix = 'st';
      } else if (day % 10 === 2 && day !== 12) {
        suffix = 'nd';
      } else if (day % 10 === 3 && day !== 13) {
        suffix = 'rd';
      } else {
        suffix = 'th';
      }
      return `${day}${suffix} ${month} ${year}`;
    },

    formatTime(dateTime) {
      if (!dateTime) return '';
      const d = new Date(dateTime);
      return d.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    },

    formatDateTime(dateTime) {
      if (!dateTime) return '';
      return `${this.formatDate(dateTime)} ${this.formatTime(dateTime)}`;
    },

    formatPhone(phone) {
      if (!phone) return '-';
      if (phone.length > 20) {
        return 'XXX-XXX-' + phone.substr(-4);
      }
      if (phone.startsWith('254')) {
        return '+' + phone;
      }
      return phone;
    },

    capitalizeName(name) {
      if (!name) return "";
      let words = name.split(" ").filter(word => word !== "");
      let capitalizedWords = words.map(word => {
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      });
      return capitalizedWords.join(" ");
    },

    printBill(billNo) {
      if (!billNo) {
        alert('No bill number available for this transaction');
        return;
      }
      localStorage['params'] = JSON.stringify({
        billNo: billNo
      });
      const routeData = this.$router.resolve({name: 'bill'});
      window.open(routeData.href, '_blank');
    },

    viewTransaction(transaction) {
      this.selectedTransaction = transaction;
      const modal = new bootstrap.Modal(document.getElementById('transactionModal'));
      modal.show();
    },

    getReceiptsPaginatedBySubCounty() {
      this.billDetails = [];
      this.loading = true;

      const data = new FormData();
      data.append("function", "getReceiptsDetailsPaginatedBySubCounty");

      if (this.pageSize === '' || this.pageSize === null) {
        // When "All" is selected, don't send page or rows_per_page
      } else {
        data.append("page", this.currentPage);
        data.append("rows_per_page", this.pageSize);
      }

      data.append("status", "PAID");
      data.append("dateFrom", this.dateFrom);
      data.append("dateTo", this.dateTo);
      data.append("subCountyName", this.subCountyName);
      data.append("subCountyID", this.subCountyID);
      data.append("keyword", this.searchQuery || "");
      data.append("incomeTypeDescription", this.incomeTypeDescription);
      data.append("feeDescription", this.feeDescription);
      data.append("incomeTypePrefix", this.incomeTypePrefix);
      data.append("maxAllowedTotal", this.amountCollected);

      execute(data, biller)
          .then((res) => {
            this.loading = false;
            this.totalAmount = null;

            if (res.data.success) {
              this.billDetails = res.data.data.billDetails;
              this.totalItems = res.data.data.summary.count || this.billDetails.length;
              this.summary = res.data.data.summary || { count: 0, total: 0 };

              if (this.pageSize === '' || this.pageSize === null) {
                this.totalPages = 1;
                this.currentPage = 1;
              } else {
                this.totalPages = Math.ceil(this.totalItems / this.pageSize);
              }

              this.totalAmount = parseFloat(res.data.data.summary.total) || 0;
            } else {
              this.message = res.data.message;
            }
          })
          .catch((e) => {
            this.loading = false;
            console.error(e);
            this.message = e.message;
          });
    },

    // Current page export
    downloadReceiptsPaginatedBySubCounty() {
      const dataToExport = this.filteredData;

      if (!dataToExport || dataToExport.length === 0) {
        alert('No data available to download. Please load data first.');
        return;
      }

      const headers = [
        'Transaction Code',
        'Receipt No',
        'Paid By',
        'Date & Time',
        'Payment Method',
        'Account Name',
        'Reference',
        'Sub County',
        'Ward',
        'Zone',
        'Description',
        'Amount'
      ];

      const csvData = dataToExport.map(item => {
        return [
          item.transaction_code || '',
          item.receiptNo || item.billNo || '-',
          this.capitalizeName(item.paidBy || item.names) || '',
          this.formatDateTime(item.date) || '',
          item.payment_type || item.source || '',
          item.accountName || '',
          item.account_ref || '-',
          item.subCountyName || '-',
          item.wardName || '-',
          item.zone || '-',
          item.description || '-',
          item.amount || item.receiptAmount || '0'
        ];
      });

      const fullData = [headers, ...csvData];

      const csvContent = fullData.map(row =>
          row.map(field => {
            const fieldStr = String(field);
            if (fieldStr.includes(',') || fieldStr.includes('"') || fieldStr.includes('\n')) {
              return '"' + fieldStr.replace(/"/g, '""') + '"';
            }
            return fieldStr;
          }).join(',')
      ).join('\n');

      const summaryData = [
        '',
        `Report Summary`,
        `==============`,
        `Total Transactions: ${dataToExport.length}`,
        `Total Amount: KES ${this.numberFormat(this.totalAmount)}`,
        `Period: ${this.formatDate(this.dateFrom)} to ${this.formatDate(this.dateTo)}`,
        `Sub County: ${this.subCountyName || 'All'}`,
        `Income Type: ${this.incomeTypeDescription || 'All'}`,
        `Fee Type: ${this.feeDescription || 'All'}`,
        `Status: ${this.incomeTypePrefix === 'UNRECIEPTED' ? 'Unreceipted Transactions' : 'All Transactions'}`,
        `Filter Applied: ${this.searchQuery || 'None'}`
      ];

      const finalCsvContent = csvContent + '\n\n' + summaryData.join('\n');

      const blob = new Blob([finalCsvContent], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');

      if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);

        const timestamp = new Date().toISOString().split('T')[0];
        const filename = `${this.subCountyName || 'Revenue'}_Report_CurrentPage_${timestamp}.csv`;
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      } else {
        window.open('data:text/csv;charset=utf-8,' + encodeURIComponent(finalCsvContent));
      }
    },

    // Export All Records
    async exportAllRecords() {
      if (this.summary.count === 0) {
        alert('No data to export');
        return;
      }

      const isConfirmed = confirm(
          `You are about to export all ${this.numberFormat(this.summary.count)} records from ${this.dateFrom} to ${this.dateTo}. This may take several minutes. Do you want to continue?`
      );

      if (!isConfirmed) return;

      this.exportingAll = true;
      this.exportPaused = false;
      this.exportCancelled = false;
      this.exportError = null;
      this.exportRetryCount = 0;
      this.allExportData = [];

      const batchSize = 1000;
      const totalRecords = this.summary.count;
      const totalPages = Math.ceil(totalRecords / batchSize);

      this.exportState = {
        startPage: 1,
        currentPage: 0,
        batchSize: batchSize,
        totalPages: totalPages,
        accumulatedData: []
      };

      this.exportProgress = {
        current: 0,
        total: totalPages,
        percentage: 0,
        records: 0,
        totalRecords: totalRecords,
        startTime: Date.now(),
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };

      const modalElement = document.getElementById('exportProgressModal');
      const progressModal = new bootstrap.Modal(modalElement);
      progressModal.show();

      await this.continueExport();
    },

    async continueExport() {
      try {
        const startPage = this.exportState.currentPage + 1;
        const totalPages = this.exportState.totalPages;

        for (let page = startPage; page <= totalPages; page++) {
          if (this.exportPaused) {
            return;
          }

          if (this.exportCancelled) {
            return;
          }

          try {
            this.exportState.currentPage = page;
            this.exportProgress.current = page;
            this.exportProgress.percentage = Math.round((page / totalPages) * 100);

            const pageData = await this.fetchExportPageWithRetry(page, this.exportState.batchSize);

            if (pageData && pageData.length > 0) {
              this.exportState.accumulatedData = [...this.exportState.accumulatedData, ...pageData];
              this.allExportData = this.exportState.accumulatedData;
              this.exportProgress.records = this.allExportData.length;

              this.calculateEstimatedTime();
            }

            this.exportRetryCount = 0;
            this.exportError = null;

            await this.delay(50);

          } catch (error) {
            console.error(`Error fetching page ${page}:`, error);
            this.exportError = error.message;
            this.exportPaused = true;
            return;
          }
        }

        await this.finalizeExport();

      } catch (error) {
        console.error('Export error:', error);
        this.exportError = error.message;
        this.exportPaused = true;
      }
    },

    async fetchExportPageWithRetry(page, rowsPerPage, retryCount = 0) {
      try {
        const data = new FormData();
        data.append("function", "getReceiptsDetailsPaginatedBySubCounty");
        data.append("page", page);
        data.append("rows_per_page", rowsPerPage);
        data.append("status", "PAID");
        data.append("dateFrom", this.dateFrom);
        data.append("dateTo", this.dateTo);
        data.append("subCountyName", this.subCountyName);
        data.append("subCountyID", this.subCountyID);
        data.append("incomeTypeDescription", this.incomeTypeDescription);
        data.append("feeDescription", this.feeDescription);
        data.append("incomeTypePrefix", this.incomeTypePrefix);

        const res = await execute(data, biller);

        if (res.data.success) {
          return res.data.data.billDetails || [];
        } else {
          throw new Error(res.data.message || 'Failed to fetch page data');
        }
      } catch (error) {
        if (retryCount < this.maxRetries) {
          this.exportRetryCount = retryCount + 1;
          console.log(`Retry ${this.exportRetryCount} for page ${page}`);

          const waitTime = Math.pow(2, retryCount) * 1000;
          await this.delay(waitTime);

          return this.fetchExportPageWithRetry(page, rowsPerPage, retryCount + 1);
        } else {
          throw new Error(`Failed after ${this.maxRetries} retries: ${error.message}`);
        }
      }
    },

    async finalizeExport() {
      if (this.allExportData.length > 0) {
        const csv = this.generateCSVContent(this.allExportData);

        const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        const timestamp = moment().format('YYYYMMDD_HHmmss');
        const fileName = `${this.subCountyName || 'Revenue'}_Report_All_${this.dateFrom}_to_${this.dateTo}_${timestamp}.csv`;

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.visibility = 'hidden';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        await this.delay(500);

        this.closeExportModal();
        alert(`Successfully exported ${this.allExportData.length} records!`);
      } else {
        alert('No records found to export');
        this.closeExportModal();
      }
    },

    generateCSVContent(data) {
      const headers = [
        'Transaction No',
        'Transaction Code',
        'Receipt No',
        'Paid By',
        'Date & Time',
        'Payment Method',
        'Account Name',
        'Reference',
        'Sub County',
        'Ward',
        'Zone',
        'Description',
        'Amount',
        'Invoiced By',
        'Invoiced By Phone',
        'Invoiced By ID',
        'Receipted By',
        'Receipted By Phone',
        'Receipted By ID',
        'Department',
        'Department ID'
      ];

      const rows = data.map((item, index) => {
        return [
          index + 1,
          this.escapeCSV(item.transaction_code || ''),
          this.escapeCSV(item.receiptNo || item.billNo || ''),
          this.escapeCSV(this.capitalizeName(item.paidBy || item.names) || ''),
          this.escapeCSV(this.formatDateTime(item.date) || ''),
          this.escapeCSV(item.payment_type || item.source || ''),
          this.escapeCSV(item.accountName || ''),
          this.escapeCSV(item.account_ref || '-'),
          this.escapeCSV(item.subCountyName || '-'),
          this.escapeCSV(item.wardName || '-'),
          this.escapeCSV(item.zone || '-'),
          this.escapeCSV(item.description || '-'),
          this.formatNumber(item.amount || item.receiptAmount || 0),
          this.escapeCSV(item.invoicedBy || '-'),
          this.escapeCSV(item.invoicedByPhoneNumber || '-'),
          this.escapeCSV(item.invoicedByIdNo || '-'),
          this.escapeCSV(item.receiptedBy || '-'),
          this.escapeCSV(item.receiptedByPhoneNumber || '-'),
          this.escapeCSV(item.receiptedByIdNo || '-'),
          this.escapeCSV(item.department || '-'),
          this.escapeCSV(item.departmentID || '-')
        ];
      });

      rows.push([]);
      rows.push([
        'TOTALS',
        '',
        '',
        '',
        '',
        '',
        '',
        `${data.length} Transactions`,
        '',
        '',
        '',
        '',
        this.formatNumber(data.reduce((sum, item) => sum + parseFloat(item.amount || item.receiptAmount || 0), 0)),
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        ''
      ]);

      const metadata = [
        ['SUB COUNTY REVENUE REPORT'],
        ['Generated on:', moment().format('DD/MM/YYYY HH:mm:ss')],
        ['Date Range:', `${this.dateFrom} to ${this.dateTo}`],
        ['Sub County:', this.subCountyName || 'All'],
        ['Income Type:', this.incomeTypeDescription || 'All'],
        ['Fee Type:', this.feeDescription || 'All'],
        ['Status:', this.incomeTypePrefix === 'UNRECIEPTED' ? 'Unreceipted Transactions' : 'All Transactions'],
        [],
        []
      ];

      const allRows = [...metadata, headers, ...rows];

      return allRows.map(row => row.join(',')).join('\n');
    },

    escapeCSV(value) {
      if (value === null || value === undefined) return '';

      const stringValue = String(value);

      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }

      return stringValue;
    },

    formatNumber(value) {
      const num = parseFloat(value) || 0;
      return num.toFixed(2);
    },

    numberFormat(num) {
      if (!num) return '0';
      const britishNumberFormatter = new Intl.NumberFormat("en-GB");
      return britishNumberFormatter.format(num);
    },

    formatTimeRemaining(seconds) {
      if (!seconds || seconds <= 0) return 'Calculating...';

      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = Math.floor(seconds % 60);

      if (hours > 0) {
        return `${hours}h ${minutes}m ${secs}s`;
      } else if (minutes > 0) {
        return `${minutes}m ${secs}s`;
      } else {
        return `${secs}s`;
      }
    },

    calculateEstimatedTime() {
      if (!this.exportProgress.startTime || this.exportProgress.current === 0) {
        return;
      }

      const elapsedTime = (Date.now() - this.exportProgress.startTime) / 1000;
      const recordsDownloaded = this.exportProgress.records;
      const remainingRecords = this.exportProgress.totalRecords - recordsDownloaded;

      if (recordsDownloaded > 0 && elapsedTime > 0) {
        const averageSpeed = recordsDownloaded / elapsedTime;
        this.exportProgress.averageSpeed = averageSpeed.toFixed(2);

        const estimatedTimeRemaining = remainingRecords / averageSpeed;
        this.exportProgress.estimatedTimeRemaining = estimatedTimeRemaining;
      }
    },

    getSuccessRate() {
      if (this.exportProgress.total === 0) return 100;
      const successfulPages = this.exportProgress.current - this.exportRetryCount;
      return Math.round((successfulPages / this.exportProgress.total) * 100);
    },

    pauseExport() {
      this.exportPaused = true;
    },

    async resumeExport() {
      this.exportPaused = false;
      this.exportError = null;
      this.exportRetryCount = 0;
      await this.continueExport();
    },

    cancelExport() {
      const confirmed = confirm('Are you sure you want to cancel the export? All progress will be lost.');

      if (confirmed) {
        this.exportCancelled = true;
        this.closeExportModal();
      }
    },

    closeExportModal() {
      const modalElement = document.getElementById('exportProgressModal');
      if (modalElement) {
        const existingModal = bootstrap.Modal.getInstance(modalElement);
        if (existingModal) {
          existingModal.hide();
        }
      }

      document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';

      this.exportingAll = false;
      this.exportPaused = false;
      this.exportCancelled = false;
      this.exportError = null;
      this.exportRetryCount = 0;
      this.allExportData = [];
      this.exportProgress = {
        current: 0,
        total: 0,
        percentage: 0,
        records: 0,
        totalRecords: 0,
        startTime: null,
        estimatedTimeRemaining: null,
        averageSpeed: 0
      };
      this.exportState = {
        startPage: 1,
        currentPage: 0,
        batchSize: 1000,
        totalPages: 0,
        accumulatedData: []
      };
    },

    delay(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    truncate(text, length) {
      if (!text) return '';
      if (text.length <= length) return text;
      return text.substring(0, length) + '...';
    }
  }
}
</script>

<style scoped>
/* Additional styles specific to this component */
.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}

.search-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #74788d;
}

.table td {
  vertical-align: middle;
}

.badge {
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
}

.stats-card {
  background: #ffffff;
  border: 1px solid #e3e6f0;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 20px;
  box-shadow: 0 0.15rem 1.75rem 0 rgba(58, 59, 69, 0.08);
  transition: all 0.3s ease;
}

.stats-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 0.25rem 2rem 0 rgba(58, 59, 69, 0.12);
}

.stats-card h3 {
  margin: 0;
  font-weight: 700;
  color: #5a5c69;
  font-size: 1.75rem;
}

.stats-card p {
  margin: 8px 0 0 0;
  color: #858796;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.stats-card.primary h3 {
  color: #4e73df;
}

.stats-card.success h3 {
  color: #1cc88a;
}

.stats-card.info h3 {
  color: #36b9cc;
}

.table-hover tbody tr:hover {
  background-color: #f8f9fa;
}

.badge-soft-success {
  background-color: #d4f8e8;
  color: #1a9e6e;
}

.search-box {
  max-width: 400px;
}

.empty-state {
  padding: 60px 20px;
}

.empty-state img {
  max-width: 200px;
  opacity: 0.6;
}

.transaction-code {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #5664d2;
}

.amount-cell {
  font-weight: 600;
  color: #28a745;
}

.receipt-no {
  font-family: 'Courier New', monospace;
  font-weight: 600;
  color: #6610f2;
}

.description-cell {
  max-width: 200px;
  word-wrap: break-word;
  white-space: normal;
  font-size: 0.875rem;
  line-height: 1.4;
}

/* Sortable header styling */
.sortable-header {
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s;
}

.sortable-header:hover {
  background-color: #e9ecef !important;
}

.sortable-header i {
  font-size: 0.875rem;
  vertical-align: middle;
}

/* Modal styling */
.modal {
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-backdrop {
  opacity: 0.5;
}

/* Custom dropdown styling */
.dropdown-menu {
  max-height: 400px;
  overflow-y: auto;
}

.dropdown-item {
  padding: 0.5rem 1rem;
}

.dropdown-item:hover {
  background-color: #f8f9fa;
}

/* Progress modal styling */
#exportProgressModal .modal-body {
  padding: 2rem;
}

#exportProgressModal .progress {
  background-color: #e9ecef;
}

#exportProgressModal .progress-bar {
  font-weight: 600;
  font-size: 0.875rem;
}

/* Pause icon animation */
.bx-pause-circle {
  animation: pulse 2s ease-in-out infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* Button group gap */
.gap-2 {
  gap: 0.5rem;
}

/* Buttons styling */
.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-group .btn {
  white-space: nowrap;
}
</style>